import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PdfIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "PDF file",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10V7.5L14.5 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10ZM14 3.5L18.5 8H14V3.5Z",
                fill: "#F2F2F2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.46 13.03C10.31 12.75 10.09 12.53 9.81 12.38C9.53 12.23 9.21 12.15 8.85 12.15C8.37 12.15 7.96 12.28 7.62 12.54C7.28 12.8 7.11 13.15 7.11 13.59C7.11 13.91 7.19 14.2 7.35 14.45C7.51 14.7 7.72 14.89 7.98 15.02C7.83 15.29 7.64 15.55 7.41 15.81C7.18 16.07 7.02 16.28 6.91 16.44L7.58 16.8C7.67 16.66 7.83 16.44 8.06 16.14C8.29 15.84 8.48 15.56 8.63 15.3L8.89 15.3C9.21 15.61 9.56 15.77 9.94 15.77C10.53 15.77 10.97 15.6 11.26 15.26C11.55 14.92 11.7 14.46 11.7 13.89C11.7 13.47 11.62 13.11 11.46 12.81C11.3 12.51 11.07 12.28 10.77 12.12L10.46 13.03ZM9.91 14.91C9.67 14.91 9.46 14.84 9.28 14.7C9.1 14.56 9.01 14.37 9.01 14.13C9.01 13.8 9.16 13.53 9.46 13.33C9.76 13.13 10.11 13.03 10.51 13.03L10.6 13.41C10.49 13.45 10.39 13.5 10.3 13.56C10.21 13.62 10.14 13.69 10.09 13.77C10.23 14.06 10.29 14.33 10.29 14.58C10.29 14.73 10.26 14.85 10.2 14.94C10.14 15.03 10.04 15.07 9.91 15.07V14.91Z",
                fill: "#F44336"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.09 12.15H15.34V16.6H14.5V12.15H12.75V11.38H17.09V12.15Z",
                fill: "#F44336"
            })
        ]
    });
export const WordIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "Word document",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7.5L14.5 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7.5Z",
                fill: "#2196F3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 2L20 7.5H14.5V2Z",
                fill: "#1976D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 12L7 18H8.2L8.6 16.5H11.4L11.8 18H13L11.5 12H10.8L10 14.5L9.2 12H8.5ZM9 14L10 11L11 14H9Z",
                fill: "white",
                transform: "translate(1.5, -1)"
            })
        ]
    });
export const ExcelIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "Excel spreadsheet",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7.5L14.5 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7.5Z",
                fill: "#4CAF50"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 2L20 7.5H14.5V2Z",
                fill: "#388E3C"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.2 12L8.5 18H9.7L10.4 16L12.6 16L13.3 18H14.5L12.8 12H11.8L11 14.5L10.2 12H10.2ZM11.5 14.5L12 13L12.5 14.5H11.5Z",
                fill: "white",
                transform: "translate(-1.5, -1)"
            })
        ]
    });
export const PowerPointIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "PowerPoint presentation",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7.5L14.5 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7.5Z",
                fill: "#FF9800"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 2L20 7.5H14.5V2Z",
                fill: "#F57C00"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 12H12.5C13.6 12 14.5 12.9 14.5 14C14.5 15.1 13.6 16 12.5 16H9.5V18H8.5V12ZM9.5 15H12.5C13.05 15 13.5 14.55 13.5 14C13.5 13.45 13.05 13 12.5 13H9.5V15Z",
                fill: "white"
            })
        ]
    });
export const ImageIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "Image file",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 21.99 21.1 21.99 20L22 4H21.99Z",
                fill: "#03A9F4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 11L11 15.51L8.5 12.5L5 17H19L14.5 11Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8.5",
                cy: "8.5",
                r: "1.5",
                fill: "white"
            })
        ]
    });
export const GenericFileIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "File",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7.5L14.5 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7.5Z",
                fill: "#B0BEC5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 2L20 7.5H14.5V2Z",
                fill: "#90A4AE"
            })
        ]
    });
